// extracted by mini-css-extract-plugin
module.exports = {"dnevnePlusWrapper":"DnevnePlus_dnevnePlusWrapper__32GNr","dnevne":"DnevnePlus_dnevne__3J0xF","circle":"DnevnePlus_circle__1l9i4"};